import React, { useState } from 'react';
import './side-navigation.scss';
import SingleSideNav from './single-side-nav';

export interface SideNavigationProps {
  id: string;
  label: string;
  sideNavContent?: React.ComponentType<any>;
}

export const SideNavigation: React.FC<{ sideTabContent: SideNavigationProps[] }> = props => {
  const [activeNav, setActiveNav] = useState(props.sideTabContent[0]);

  const changeActiveTab = (navItem: SideNavigationProps) => {
    setActiveNav(navItem);
  };
  return (
    <>
      <div className="custom-side-nav-container">
        <div className="custom-side-nav-container_left">
          {props.sideTabContent.map((navItem, index) => (
            <div className="single-side-nav" key={index} onClick={() => changeActiveTab(navItem)}>
              <SingleSideNav key={index} id={navItem.id} label={navItem.label} currentActiveNav={activeNav?.id ?? ''} />
            </div>
          ))}
        </div>
        <div className="custom-side-nav-container_right">{React.createElement(activeNav?.sideNavContent || '')}</div>
      </div>
    </>
  );
};